import React from 'react';
import PropTypes from 'prop-types';
import { Accordion, Icon } from 'semantic-ui-react';

export class SFAccordion extends React.Component {

  static defaultProps = {
    expandable: true,
    initiallyExpanded: false
  };

  constructor(props) {
    super(props);
    this.state = { expanded: Boolean(props.expandable && props.initiallyExpanded) };
  }

  get expanded() {
    return this.state.expanded;
  }

  UNSAFE_componentWillReceiveProps({expandable}) {
    if (!expandable && this.expanded) this.setState({expanded: false});
  }

  handleExpand = e => {
    if (!this.props.expandable) {
      e.preventDefault();
      return;
    }

    const newlyExpanded = !this.expanded;

    e.target.setAttribute("aria-expanded", newlyExpanded);
    this.setState({expanded: newlyExpanded});

    if (this.props.onExpanded) this.props.onExpanded(newlyExpanded);
  };

  render () {
    return (
      <Accordion styled className={this.props.className}>
        <Accordion.Title
            tabIndex="0"
            role="button"
            className={this.props.titleClass}
            aria-expanded="false"
            onClick={this.handleExpand}
            active={this.expanded}>
          <Icon name="dropdown" />
          {this.props.title}
        </Accordion.Title>
        <Accordion.Content role="region" active={this.expanded}>
          {this.props.children}
        </Accordion.Content>
      </Accordion>
    );
  }
}

SFAccordion.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  titleClass: PropTypes.string,
  children: PropTypes.node.isRequired,
  expandable: PropTypes.bool,
  initiallyExpanded: PropTypes.bool,
  onExpanded: PropTypes.func,
};

export default SFAccordion;
